import { useState, useEffect } from 'react'
import styles from '../styles/NodeDocument.module.css'

const useIntroTour = (id: string, selectedSectionId: string | null) => {
  const [introEnabled, setIntroEnabled] = useState(false)
  const [introSteps, setIntroSteps] = useState<any[]>([])

  useEffect(() => {
    const nodeSelector = `[data-id="${id}"]`
    setIntroSteps([
      { element: nodeSelector, intro: 'This is the Document Node. It allows you to create, edit, and manage document content using Markdown format.', position: 'right' },
      { element: `${nodeSelector} h2.${styles.title}`, intro: 'Click on the title to edit it. The title helps you identify your document.', position: 'bottom' },
      { element: `${nodeSelector} .${styles.nodeHeader}`, intro: 'These action buttons let you assign users, configure, link and filter incoming data, lock, minimize, duplicate, or delete the document node.', position: 'bottom' },
      { element: `${nodeSelector} [data-pc-section="nav"]`, intro: 'These tabs let you switch between different views of your document.', position: 'bottom' },
      { element: `${nodeSelector} [data-pc-section="header"]:nth-child(1)`, intro: 'Document tab shows the rendered Markdown with formatted text, lists, and other elements.', position: 'bottom' },
      { element: `${nodeSelector} [data-pc-section="header"]:nth-child(2)`, intro: 'Markdown (editable raw) tab lets you directly edit the raw Markdown content giving you full freedom to shape the document to your likings.', position: 'bottom' },
      { element: `${nodeSelector} [data-pc-section="header"]:nth-child(3)`, intro: 'Context tab lets you modify the context for the document. When crafting context will be included for the AI to create content.', position: 'bottom' },
      { element: `${nodeSelector} [data-pc-section="header"]:nth-child(4)`, intro: 'Linked knowledge tab shows you all the information that is included from other documents and knowledge sets in this project. This information will be included for the AI to create content When crafting.', position: 'bottom' },
      { element: `${nodeSelector} select.nodrag`, intro: 'Select a document style to change the tone and formatting of your document.', position: 'bottom' },
      { element: `${nodeSelector} .copy-button`, intro: 'Copy your document to clipboard in both HTML and plain text formats.', position: 'left' },
      { element: `${nodeSelector} .expand-button`, intro: 'Expand or collapse the document view to show more or less content.', position: 'left' },
      { element: `${nodeSelector} .assignedEmails`, intro: 'This area shows users assigned to work on this document.', position: 'bottom' },
      ...(selectedSectionId ? [
        { element: `${nodeSelector} [data-section-id="${selectedSectionId}"]`, intro: 'Sections in your document are highlighted and can be selected for editing.', position: 'bottom' },
        { element: `${nodeSelector} [data-section-id="${selectedSectionId}"]`, intro: 'When a section is selected, you can edit it or apply transformations using the system agent.', position: 'bottom' },
      ] : []),
    ])
  }, [id, selectedSectionId])

  const introOptions = {
    nextLabel: 'Next',
    prevLabel: 'Back',
    skipLabel: 'Skip',
    doneLabel: 'Done',
    hidePrev: false,
    hideNext: false,
    tooltipClass: 'document-node-tooltip',
    highlightClass: 'document-node-highlight',
    exitOnEsc: true,
    exitOnOverlayClick: false,
    showStepNumbers: true,
    keyboardNavigation: true,
    showButtons: true,
    showBullets: true,
    showProgress: true,
    scrollToElement: true,
    overlayOpacity: 0.8,
  }

  return { introEnabled, setIntroEnabled, introSteps, introOptions }
}

export default useIntroTour